import { NavLink } from 'react-router-dom'
import { ROUTES } from '@metal/shared'
import { Icon, type IconName } from '@metal/ui'
import { useSession } from '@metal/ui/session'

function tabs(sides: Array<'buy' | 'sell'>): Array<{ to: string; label: string; icon: IconName }> {
  const sells = sides.includes('sell')
  return [
    { to: ROUTES.board(), label: 'تابلو', icon: 'chart' },
    sells
      ? { to: ROUTES.myOffers(), label: 'عرضه‌ها', icon: 'cathode' }
      : { to: ROUTES.myRfqs(), label: 'تقاضاها', icon: 'list' },
    { to: ROUTES.deals(), label: 'معاملات', icon: 'doc' },
    { to: ROUTES.wallet(), label: 'کیف پول', icon: 'wallet' },
    { to: ROUTES.settingsProfile(), label: 'پروفایل', icon: 'user' },
  ]
}

export function MobileTabBar() {
  const { user } = useSession()

  return (
    <nav className="tabbar" aria-label="ناوبری موبایل">
      {tabs(user?.sides ?? ['sell']).map((t) => (
        <NavLink key={t.to} to={t.to} className={({ isActive }) => (isActive ? 'is-on' : undefined)}>
          <Icon name={t.icon} />
          {t.label}
        </NavLink>
      ))}
    </nav>
  )
}
